import { createContext } from 'react';

const PopupContext = createContext<any>({
  isPopupVisible: false,
  popupData: {},
  setPopupVisibility: () => null,
  setPopupData: () => null,
});

export default PopupContext;
